<template>
	<div>
		<footer class="py-4 mt-4">
			<div class="container text-center">
				<small>Copyright &copy; Tkt</small>
			</div>
		</footer>
		<!-- <div class="footer-separator"></div> -->
	</div>
</template>

<script>
export default {
	name: 'Footer',
}
</script>

<style>
footer {
	width: 100%;
}
</style>
